import { Card } from "../../models/card";
import { cards, questFlags } from "../../state";
import { Fire } from "../resources/fire";
export class MakeFire extends Card {
}
MakeFire.displayName = "Fire";
MakeFire.artUrl = "./assets/cards/makefire.jpg";
MakeFire.effect = {
    callback: () => {
        cards.push(new Fire({ x: 8, y: 240 }));
        questFlags.hasCraftedFire = true;
    },
    description: "Gives you Fire",
    needsFeedback: true,
};
MakeFire.destroysOnPlay = true;
